import { utils, enableBodyScroll, disableBodyScroll } from '@hh/global.js'

/* mobile menu sideways panels */
const sidePanelOpen = document.querySelectorAll('[data-open-sidepanel]')
const sidePanelBody = document.querySelectorAll('[data-sidepanel]')
const sidePanelClose = document.querySelectorAll('[data-close-sidepanel]')

let lastFocusedElement

const toggleSidePanel = (index) => {
  const sidePanel = sidePanelBody[index]
  const isActive = !sidePanel.hasAttribute('hidden')

  const togglePanelState = () => {
    if (!isActive) {
      lastFocusedElement = document.activeElement
      sidePanel.removeAttribute('hidden')
      utils.trapFocus(sidePanel)
    } else {
      sidePanel.setAttribute('hidden', 'true')
      if (lastFocusedElement) {
        lastFocusedElement.focus({ focusVisible: true })
      }
    }
  }

  togglePanelState()
}

const handleSidePanelToggle = (event) => {
  const target = event.target
  const trigger = target.closest('[data-open-sidepanel]')
  const triggerClose = target.closest('[data-close-sidepanel]')

  if (trigger) {
    const index = Array.from(sidePanelOpen).indexOf(trigger)
    toggleSidePanel(index)
  } else if (triggerClose) {
    const index = Array.from(sidePanelClose).indexOf(triggerClose)
    toggleSidePanel(index)
  }
}

/* mouse click and keyboard enter toggling */
document.addEventListener('click', handleSidePanelToggle)

document.addEventListener('keydown', function (event) {
  const isEnterPressed = event.code === 'Enter'
  if (isEnterPressed) {
    handleSidePanelToggle(event)
  }
})

/* Country Selector - Mobile */
const mobileLocalizationForm = document.querySelector('[data-mobile-localization]')
if (mobileLocalizationForm) {
  const form = mobileLocalizationForm
  const trigger = mobileLocalizationForm.querySelector('[data-accordion-trigger]')
  const content = mobileLocalizationForm.querySelector('[data-accordion-content]')
  const buttons = mobileLocalizationForm.querySelectorAll('a')
  
  // Handle accordion toggle
  trigger.addEventListener('click', () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true'
    trigger.setAttribute('aria-expanded', !isExpanded)
    content.hidden = isExpanded
  })

  const handleCountrySelect = (button) => {
    mobileLocalizationForm.querySelector('input[name="country_code"]').value = button.dataset.value
    if (form) form.submit()
  }

  const handleClick = (event) => {
    const button = event.target.closest('a')
    if (button) {
      event.preventDefault()
      handleCountrySelect(button)
    }
  }

  const handleKeyDown = (event) => {
    if (event.code === 'Enter') {
      const button = event.target.closest('a')
      if (button) {
        event.preventDefault()
        handleCountrySelect(button)
      }
    }
  }

  buttons.forEach((button) => {
    button.addEventListener('click', handleClick)
    button.addEventListener('keydown', handleKeyDown)
  })
}

/* Search functionality */
const searchButtons = document.querySelectorAll('[data-mobile-search-button]')
const searchInputs = document.querySelectorAll('[data-mobile-search-input]')

searchButtons.forEach((button, index) => {
  button.addEventListener('click', () => {
    const input = searchInputs[index]
    // input.style.display = 'block'
    input.click();
    input.focus();
  })
})

/* Mobile menu drawer toggle */
const mobileMenuIcon = document.querySelector('.mobile-menu__icon')
const mobileMenuDrawer = document.querySelector('.mobile-menu__drawer')
const mobileMenuClose = document.querySelector('.mobile-menu__close')

if (mobileMenuIcon && mobileMenuDrawer) {
  // Create overlay element
  const overlay = document.createElement('div')
  overlay.className = 'bg-overlay'

  // Open menu
  mobileMenuIcon.addEventListener('click', () => {
    mobileMenuDrawer.classList.add('active')
    document.body.appendChild(overlay);
    overlay.classList.add('active');
    disableBodyScroll(document.body);
  })

  // Close menu
  mobileMenuClose.addEventListener('click', () => {
    mobileMenuDrawer.classList.remove('active')
    overlay.classList.remove('active')
    enableBodyScroll(document.body);
  })
}

